import React, { createContext, useState, useEffect } from "react";

const AccessTokenContext = createContext();

// Served by setupProxy.js in the CRA dev-server — generates the token
// server-side from the local service account key. No external server needed.
const TOKEN_URL = "/get_access_token";

export const AccessTokenProvider = ({ children }) => {
  const [accessToken, setAccessToken] = useState(null);

  const getAccessFcmAccessToken = async () => {
    try {
      const response = await fetch(TOKEN_URL, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });

      if (!response.ok) {
        throw new Error(`Token fetch failed: ${response.status}`);
      }

      const data = await response.json();
      if (data?.access_token) {
        localStorage.setItem("@accessToken", data.access_token);
        setAccessToken(data.access_token);
      }
    } catch (error) {
      console.error("[AccessToken] Error fetching FCM token:", error);
    }
  };

  useEffect(() => {
    getAccessFcmAccessToken();
  }, []);

  return (
    <AccessTokenContext.Provider value={{ accessToken, getAccessFcmAccessToken }}>
      {children}
    </AccessTokenContext.Provider>
  );
};

export default AccessTokenContext;
